import Phaser from 'phaser';

export default class Button extends Phaser.Group {
    constructor(game, parent, sprite, label, fontSize, callback) {
        super(game, parent);

        this.sprite = sprite;
        this.label = label;
        this.fontSize = fontSize || 50;
        this.callback = callback;

        this.init();
    }

    init() {
        let bg = this.game.add.sprite(0, 0, "sheet", this.sprite);
        bg.anchor.set(0.5);
        this.add(bg);

        this.text = this.game.add.bitmapText(0, 0, "font-title", this.label, this.fontSize);
        this.text.align = "center";
        this.text.anchor.set(0.5);
        this.add(this.text);

        if (this.callback) {
            bg.inputEnabled = true;
            bg.events.onInputUp.add(this.callback);
        }
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/objects/ui/Button.js
// module id = 72
// module chunks = 0